import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { questions } from '../data/questions';
import ProgressBar from './ProgressBar';
import AdBanner from './AdBanner';

function QuestionPage() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [answers, setAnswers] = useState({});
  const navigate = useNavigate();
  
  const currentQuestion = questions[currentIndex];
  const progress = Math.floor((currentIndex / questions.length) * 100);
  
  // 답변 처리 함수
  const handleAnswer = (score) => {
    // 현재 질문에 대한 응답 저장 (질문 인덱스가 아닌 ID 사용)
    const newAnswers = { 
      ...answers, 
      [currentQuestion.id]: {  // 여기가 수정된 부분
        dimension: currentQuestion.dimension, 
        direction: currentQuestion.direction, 
        score 
      }
    };
    setAnswers(newAnswers);
    
    // 다음 질문으로 이동 또는 결과 페이지로 이동
    if (currentIndex < questions.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      // 결과 계산 및 결과 페이지로 이동
      calculateResult(newAnswers);
    }
  };
  
  // MBTI 결과 계산
  const calculateResult = (answers) => {
    const dimensions = {
      'E-I': { E: 0, I: 0 },
      'S-N': { S: 0, N: 0 },
      'T-F': { T: 0, F: 0 },
      'J-P': { J: 0, P: 0 }
    };
    
    // 각 질문에 대한 응답 점수 합산 (수정된 알고리즘)
    Object.values(answers).forEach(answer => {
      const { dimension, direction, score } = answer;
      
      // 방향성 반영한 점수 계산:
      // 1. "매우 그렇다"(5점)와 방향이 일치하면 최대 점수
      // 2. "전혀 아니다"(1점)와 방향이 일치하면 최소 점수
      const calculatedScore = score;
      dimensions[dimension][direction] += calculatedScore;
      
      // 반대 방향은 반대 점수 (6-score)로 계산
      const oppositeDirection = direction === 'E' ? 'I' : 
                               direction === 'I' ? 'E' : 
                               direction === 'S' ? 'N' : 
                               direction === 'N' ? 'S' : 
                               direction === 'T' ? 'F' : 
                               direction === 'F' ? 'T' : 
                               direction === 'J' ? 'P' : 'J';
                               
      // 이 부분이 핵심! 질문에 동의하지 않으면 반대 성향에 점수 추가
      dimensions[dimension][oppositeDirection] += (6 - calculatedScore);
      
      console.log(`차원: ${dimension}, 방향: ${direction}, 점수: ${score}, 반대방향: ${oppositeDirection}, 반대점수: ${6-score}`);
    });
    
    console.log("차원별 점수:", dimensions);
    
    // 최종 MBTI 유형 결정
    let mbtiResult = '';
    mbtiResult += dimensions['E-I'].E > dimensions['E-I'].I ? 'E' : 'I';
    mbtiResult += dimensions['S-N'].S > dimensions['S-N'].N ? 'S' : 'N';
    mbtiResult += dimensions['T-F'].T > dimensions['T-F'].F ? 'T' : 'F';
    mbtiResult += dimensions['J-P'].J > dimensions['J-P'].P ? 'J' : 'P';
    
    console.log("최종 MBTI 결과:", mbtiResult);
    
    // 결과 페이지로 이동
    navigate('/result', { state: { mbtiResult } });
  };
  
  // 동점일 경우 처리하는 함수
  const getPreference = (score1, score2, option1, option2) => {
    if (score1 === score2) {
      // 동점일 경우 약간의 무작위성 추가 (또는 다른 규칙 적용 가능)
      return Math.random() > 0.5 ? option1 : option2;
    }
    return score1 > score2 ? option1 : option2;
  };
  
  // 광고 표시 여부 (5문제마다)
  const showAd = currentIndex > 0 && currentIndex % 5 === 0;
  
  return (
    <div className="container mt-4">
      <ProgressBar progress={progress} />
      
      <div className="question-container my-4">
        <h3 className="text-center mb-4">질문 {currentIndex + 1}/{questions.length}</h3>
        <div className="card p-4">
          <h2 className="card-title text-center mb-4">{currentQuestion.text}</h2>
          
          <div className="d-grid gap-2">
            <button className="btn btn-outline-primary" onClick={() => handleAnswer(5)}>매우 그렇다</button>
            <button className="btn btn-outline-primary" onClick={() => handleAnswer(4)}>그렇다</button>
            <button className="btn btn-outline-secondary" onClick={() => handleAnswer(3)}>보통이다</button>
            <button className="btn btn-outline-primary" onClick={() => handleAnswer(2)}>아니다</button>
            <button className="btn btn-outline-primary" onClick={() => handleAnswer(1)}>전혀 아니다</button>
          </div>
        </div>
      </div>
      
      {/* 광고 표시 영역 */}
      {showAd && (
        <div className="ad-container my-3 text-center">
          <AdBanner adSlot="2345678901" format="rectangle" />
        </div>
      )}
    </div>
  );
}

export default QuestionPage;